export default ({ app }, inject) => {
  const PDFJS = require('pdfjs-dist/webpack')
  // Inject $hello(msg) in Vue, context and store.
  inject('PDFJS', PDFJS)
}
